/**
 * Scales a docx-preview rendering down so its pages fit the container's
 * width.
 *
 * docx-preview lays every page out at the document's real page width
 * (about 800px for A4/Letter), centred in a flex wrapper. Inside a
 * narrower container that centring overflows on BOTH sides, so the left
 * edge of the page is clipped and cannot be scrolled to. Scaling the
 * wrapper (rather than letting it overflow) keeps the whole page
 * readable at any container width; it never scales UP past 100%.
 */
export default function fitDocxToWidth(container) {
  const wrapper = container?.querySelector('.docx-wrapper');
  if (!wrapper) return;

  // Measure at natural size: offsetWidth of a zoomed element is not
  // reliable across browsers.
  wrapper.style.zoom = '1';

  const pageWidth = Math.max(
    0,
    ...Array.from(wrapper.querySelectorAll('section.docx'), (page) => page.offsetWidth)
  );
  if (!pageWidth) return;

  const style = window.getComputedStyle(wrapper);
  const wrapperPadding =
    (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0);

  const scale = Math.min(1, container.clientWidth / (pageWidth + wrapperPadding));

  wrapper.style.zoom = String(scale);
}
